import { configureStore } from '@reduxjs/toolkit';
import { GLOBAL } from 'data/constants';
import { api } from 'services/api';

export const initializeStore = (rootReducer) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
    devTools: GLOBAL.isDevelopment, // process.env.NODE_ENV === 'development',
  });
};
